module.exports = __webpack_public_path__ + "static/img/step4.156a259a.png";